<template>
  <popup
    :opened="isAddGuestPopupOpened"
    @close="close"
    :no-close-button="step === 'permissions'"
  >
    <div v-if="step === 'add_guest'">
      <div class="mx-5 xl:mx-44 2xl:mx-40 my-8 w-auto h-auto">
        <h3 class="mb-15">Ajouter un invité</h3>

        <h6 class="text-indigo-600 my-5 mb-9">
          Veuillez saisir les informations du nouvel invité à ajouter
        </h6>

        <form autocomplete="off" @submit.prevent>
          <div class="grid grid-cols-12 gap-x-4 gap-y-5">
            <input-text
              name="Prénom"
              class="lg:col-span-6"
              libelle="Prénom"
              :value="newGuest.firstname"
              @input="
                (newValue) => {
                  newGuest.firstname = newValue;
                }
              "
              :error="true"
              :msg-error="((errors || []).firstname || [])[0]"
              :required="true"
            />
            <input-text
              name="Nom"
              class="lg:col-span-6"
              libelle="Nom"
              :value="newGuest.lastname"
              @input="
                (newValue) => {
                  newGuest.lastname = newValue;
                }
              "
              :error="true"
              :msg-error="((errors || []).lastname || [])[0]"
              :required="true"
            />
            <input-text
              class="lg:col-span-6"
              libelle="Email"
              :value="newGuest.email"
              @input="
                (newValue) => {
                  newGuest.email = newValue;
                }
              "
              :msg-error="((errors || []).email || [])[0]"
              :error="true"
              :required="true"
            />
            <input-text
              class="lg:col-span-6"
              libelle="Fonction"
              :value="newGuest.function"
              @input="
                (newValue) => {
                  newGuest.function = newValue;
                }
              "
              :msg-error="((errors || []).function || [])[0]"
              :error="true"
            />
            <input-text
              class="lg:col-span-6"
              libelle="Structure"
              :value="newGuest.structure"
              @input="
                (newValue) => {
                  newGuest.structure = newValue;
                }
              "
              :msg-error="((errors || []).structure || [])[0]"
              :error="true"
            />
            <div class="col-span-full justify-self-center mt-5 flex space-x-4">
              <action-button
                border-color="border-transparent"
                text-color="text-white"
                bg-color="bg-indigo-600"
                bg-color-square="bg-indigo-600"
                icon-color="text-white"
                libelle="Droits d'accès spécifiques"
                icon="options"
                :right="true"
                type-shadow="shadow-indigo"
                :uppercase="true"
                @clickAction="permissionsStep()"
              />

              <action-button
                v-if="saving_new"
                border-color="border-transparent"
                text-color="text-white"
                bg-color="bg-pink-600"
                bg-color-square="bg-pink-600"
                icon-color="text-white"
                libelle="CREER"
                :spinner="true"
                :right="true"
                type-shadow="shadow-pink"
              />

              <action-button
                v-else
                border-color="border-transparent"
                text-color="text-white"
                bg-color="bg-pink-600"
                bg-color-square="bg-pink-600"
                icon-color="text-white"
                libelle="CRÉER"
                icon="arrow-right_1"
                :right="true"
                type-shadow="shadow-pink"
                @clickAction="createGuest()"
              />
            </div>
          </div>
        </form>

        <!-- <h5 class="my-10">OU</h5>

                <h6 class="text-indigo-600 mb-10">
                    Si vous souhaitez inviter un utilisateur existant,
                    <br />
                    veuillez saisir son identifiant ou son adresse email
                </h6>

                <form 
                    autocomplete="off" 
                    @submit.prevent
                >
                    <div class="grid grid-cols-11 gap-x-4 gap-y-10 mb-10" >
                        <input-text
                            class="lg:col-span-5"
                            libelle="Identifiant"
                            :value="existingGuest.username" @input="(newValue) => {existingGuest.username = newValue}"
                            :msgError="((errors || []).username || [])[0]"
                            :error="true"
                        />

                        <span class="col-span-1 place-self-center mt-5 text-indigo-600">OU</span>

                        <input-text
                            class="lg:col-span-5"
                            libelle="Email"
                            :value="existingGuest.email" @input="(newValue) => {existingGuest.email = newValue}"
                            :msgError="((errors || []).email || [])[0]"
                            :error="true"
                        />

                        <div v-if="saving_existing"
                        class="col-span-full justify-self-center"
                        >
                            <action-button
                                borderColor="border-transparent"
                                textColor="text-white"
                                bgColor="bg-pink-600"
                                bgColorSquare="bg-pink-600"
                                iconColor="text-white"
                                libelle="INVITER"
                                :spinner="true"
                                :right="true"
                                typeShadow="shadow-pink"
                            />
                        </div>
                        <div v-else
                            class="col-span-full justify-self-center"
                        >
                            <action-button
                                borderColor="border-transparent"
                                textColor="text-white"
                                bgColor="bg-pink-600"
                                bgColorSquare="bg-pink-600"
                                iconColor="text-white"
                                libelle="INVITER"
                                icon="arrow-right_1"
                                :right="true"
                                typeShadow="shadow-pink"
                                @clickAction="inviteExistingGuest()"
                            />
                        </div>
                    </div>
                </form> -->
      </div>
    </div>

    <div v-else-if="step === 'permissions'">
      <div class="m-5 lg:m-15 2xl:m-20">
        <h3 class="w-full text-pink-600 mb-10">Droits d'accès spécifiques</h3>

        <div
          @click="step = 'add_guest'"
          class="flex items-center space-x-2 w-max transform hover:scale-110 duration-300 cursor-pointer mb-5"
        >
          <div class="text-white bg-pink-600 p-3 rounded-full w-max">
            <icon name="arrow-right_1" class="w-4 h-4 transform rotate-180" />
          </div>
          <div>Retour</div>
        </div>

        <div class="flex justify-between">
          <div class="flex-none">
            <div v-if="listNeopassModulesPages">
              <checkbox-indigo
                name="Lecture"
                libelle="LECTURE"
                color-libelle="indigo-600"
                :value="
                  (
                    (
                      ((specificRightsToEdit || {}).rights || {}).neopassForm ||
                      {}
                    ).read || {}
                  ).all
                "
                @input="
                  (newValue) => {
                    (
                      (
                        ((specificRightsToEdit || {}).rights || {})
                          .neopassForm || {}
                      ).read || {}
                    ).all = newValue;
                    checkall('read', 'all', newValue);

                    if (!newValue) {
                      (
                        (
                          ((specificRightsToEdit || {}).rights || {})
                            .neopassForm || {}
                        ).edit || {}
                      ).all = newValue;
                      checkall('edit', 'all', newValue);
                    }
                  }
                "
                class="text-indigo-600"
                size-libelle="text-base"
              />
            </div>
            <div
              v-for="(mod, numMod) in listNeopassModulesPages.filter(
                (m) => m.name != constants.MODULE_NEOPASS_FORM_DEPOT_DOCUMENTS
              )"
              :key="numMod"
              class="m-3"
            >
              <div>
                <checkbox-indigo
                  :name="mod.name"
                  :libelle="mod.display_name"
                  :value="
                    (
                      ((
                        ((specificRightsToEdit || {}).rights || {})
                          .neopassForm || {}
                      ).read || {})[mod.name] || {}
                    ).all
                  "
                  @input="
                    (newValue) => {
                      (
                        ((
                          ((specificRightsToEdit || {}).rights || {})
                            .neopassForm || {}
                        ).read || {})[mod.name] || {}
                      ).all = newValue;
                      checkall('read', mod.name, newValue);
                      decheckall('read', mod.name, newValue);

                      if (!newValue) {
                        (
                          ((
                            ((specificRightsToEdit || {}).rights || {})
                              .neopassForm || {}
                          ).edit || {})[mod.name] || {}
                        ).all = newValue;
                        checkall('edit', mod.name, newValue);
                        decheckall('edit', mod.name, newValue);
                      }
                    }
                  "
                  class="mb-1.5"
                  size-libelle="text-base"
                />
              </div>

              <div
                v-for="(page, numPage) in mod.pages.filter(
                  (p) => p.name != constants.PAGE_NEOPASS_FORM_DOCUMENTS
                )"
                :key="numPage"
              >
                <checkbox-indigo
                  :name="page.name"
                  :libelle="page.display_name"
                  :value="
                    (((
                      ((specificRightsToEdit || {}).rights || {}).neopassForm ||
                      {}
                    ).read || {})[mod.name] || {})[page.name]
                  "
                  @input="
                    (newValue) => {
                      (((
                        ((specificRightsToEdit || {}).rights || {})
                          .neopassForm || {}
                      ).read || {})[mod.name] || {})[page.name] = newValue;
                      decheckall('read', mod.name, newValue);

                      if (!newValue) {
                        (((
                          ((specificRightsToEdit || {}).rights || {})
                            .neopassForm || {}
                        ).edit || {})[mod.name] || {})[page.name] = newValue;
                        decheckall('edit', mod.name, newValue);
                      }
                    }
                  "
                  color-libelle="text-gray-600"
                  size-libelle="text-base"
                  weight-libelle="font-light"
                />
              </div>
              <checkbox-indigo
                v-if="permissions.includes(mod.name + '_auto_eval_read')"
                :name="mod.name + '_auto_eval_read'"
                libelle="Auto Evaluation Bénéficiaire"
                color-libelle="gray-600"
                :value="
                  (((
                    ((specificRightsToEdit || {}).rights || {}).neopassForm ||
                    {}
                  ).read || {})[mod.name] || {})['auto_eval']
                "
                @input="
                  (newValue) => {
                    (((
                      ((specificRightsToEdit || {}).rights || {}).neopassForm ||
                      {}
                    ).read || {})[mod.name] || {})['auto_eval'] = newValue;
                    decheckall('read', mod.name, newValue);
                    if (!newValue) {
                      (((
                        ((specificRightsToEdit || {}).rights || {})
                          .neopassForm || {}
                      ).edit || {})[mod.name] || {})['auto_eval'] = newValue;
                      decheckall('edit', mod.name, newValue);
                    }
                  }
                "
                class="text-gray-600"
                size-libelle="text-base"
                weight-libelle="font-light"
              />
            </div>
          </div>
          <div class="flex-grow" />
          <div class="flex-none">
            <div v-if="listNeopassModulesPages">
              <checkbox-indigo
                name="Ecriture"
                libelle="ECRITURE"
                :value="
                  (
                    (
                      ((specificRightsToEdit || {}).rights || {}).neopassForm ||
                      {}
                    ).edit || {}
                  ).all
                "
                @input="
                  (newValue) => {
                    (
                      (
                        ((specificRightsToEdit || {}).rights || {})
                          .neopassForm || {}
                      ).edit || {}
                    ).all = newValue;
                    checkall('edit', 'all', newValue);

                    if (newValue) {
                      (
                        (
                          ((specificRightsToEdit || {}).rights || {})
                            .neopassForm || {}
                        ).read || {}
                      ).all = newValue;
                      checkall('read', 'all', newValue);
                    }
                  }
                "
                color-libelle="text-indigo-600"
                size-libelle="text-base"
              />
            </div>
            <div
              v-for="(mod, numMod) in listNeopassModulesPages.filter(
                (m) => m.name != constants.MODULE_NEOPASS_FORM_DEPOT_DOCUMENTS
              )"
              :key="numMod"
              class="m-3"
            >
              <div>
                <checkbox-indigo
                  :name="mod.name"
                  :libelle="mod.display_name"
                  :value="
                    (
                      ((
                        ((specificRightsToEdit || {}).rights || {})
                          .neopassForm || {}
                      ).edit || {})[mod.name] || {}
                    ).all
                  "
                  @input="
                    (newValue) => {
                      (
                        ((
                          ((specificRightsToEdit || {}).rights || {})
                            .neopassForm || {}
                        ).edit || {})[mod.name] || {}
                      ).all = newValue;
                      checkall('edit', mod.name, newValue);
                      decheckall('edit', mod.name, newValue);

                      if (newValue) {
                        (
                          ((
                            ((specificRightsToEdit || {}).rights || {})
                              .neopassForm || {}
                          ).read || {})[mod.name] || {}
                        ).all = newValue;
                        checkall('read', mod.name, newValue);
                      }
                    }
                  "
                  class="mb-1.5"
                  size-libelle="text-base"
                />
              </div>
              <div
                v-for="(page, numPage) in mod.pages.filter(
                  (p) => p.name != constants.PAGE_NEOPASS_FORM_DOCUMENTS
                )"
                :key="numPage"
              >
                <checkbox-indigo
                  :name="page.name"
                  :libelle="page.display_name"
                  :value="
                    (((
                      ((specificRightsToEdit || {}).rights || {}).neopassForm ||
                      {}
                    ).edit || {})[mod.name] || {})[page.name]
                  "
                  @input="
                    (newValue) => {
                      (((
                        ((specificRightsToEdit || {}).rights || {})
                          .neopassForm || {}
                      ).edit || {})[mod.name] || {})[page.name] = newValue;
                      decheckall('edit', mod.name, newValue);

                      if (newValue) {
                        (((
                          ((specificRightsToEdit || {}).rights || {})
                            .neopassForm || {}
                        ).read || {})[mod.name] || {})[page.name] = newValue;
                      }
                    }
                  "
                  color-libelle="text-gray-600"
                  size-libelle="text-base"
                  weight-libelle="font-light"
                />
              </div>
              <checkbox-indigo
                v-if="permissions.includes(mod.name + '_auto_eval_edit')"
                :name="mod.name + '_auto_eval_edit'"
                libelle="Auto Evaluation Bénéficiaire"
                color-libelle="gray-600"
                :value="
                  (((
                    ((specificRightsToEdit || {}).rights || {}).neopassForm ||
                    {}
                  ).edit || {})[mod.name] || {})['auto_eval']
                "
                @input="
                  (newValue) => {
                    (((
                      ((specificRightsToEdit || {}).rights || {}).neopassForm ||
                      {}
                    ).edit || {})[mod.name] || {})['auto_eval'] = newValue;
                    decheckall('edit', mod.name, newValue);
                    if (newValue) {
                      (((
                        ((specificRightsToEdit || {}).rights || {})
                          .neopassForm || {}
                      ).read || {})[mod.name] || {})['auto_eval'] = newValue;
                    }
                  }
                "
                class="text-gray-600"
                size-libelle="text-base"
                weight-libelle="font-light"
              />
            </div>
          </div>
        </div>
        <div class="flex justify-center mt-10">
          <action-button
            border-color="border-transparent"
            text-color="text-white"
            bg-color="bg-pink-600"
            bg-color-square="bg-pink-600"
            icon-color="text-white"
            libelle="Valider"
            icon="checkmark-circle"
            :right="true"
            type-shadow="shadow-pink"
            :uppercase="true"
            @clickAction="infosGuestStep()"
          />
        </div>
      </div>
    </div>

    <div v-else-if="step === 'success'">
      <div class="m-5 lg:m-15 2xl:m-20">
        <h3 class="w-full text-pink-600 mb-10">Invitation envoyée !</h3>

        <div class="mb-10">
          <p class="text-indigo-600 text-lg text-center">
            L’invitation a été transmise à {{ newGuest.firstname }}
            <span class="uppercase">{{ newGuest.lastname }}</span
            >, à l'adresse email {{ newGuest.email }}
          </p>
        </div>

        <illustration name="basket" class="w-full" />
      </div>
    </div>

    <div v-else-if="step === 'limit'">
      <div class="m-5 lg:m-15 2xl:m-20">
        <h3 class="w-full text-pink-600 mb-10">Un seul invité autorisé</h3>

        <div class="mb-10">
          <p class="text-indigo-600 text-lg text-center">
            Votre compte gratuit ne vous permet d'inviter qu'une seule personne
          </p>
          <p class="text-indigo-600 text-lg text-center">
            Si vous souhaitez inviter plusieurs personnes simultanément, vous
            pouvez passer à
            <span class="cursor-pointer text-pink-600"
              >l'abonnement Premium</span
            >
          </p>
        </div>

        <illustration name="basket" class="w-full" />
      </div>
    </div>

    <div v-else-if="step === 'already_invited'">
      <div class="m-5 lg:m-15 2xl:m-20">
        <h3 class="w-full text-pink-600 mb-10">Utilisateur déjà invité</h3>

        <div class="mb-10">
          <p class="text-indigo-600 text-lg text-center">
            Votre compte gratuit ne vous permet d'inviter une seule fois une
            même personne
          </p>
          <p class="text-indigo-600 text-lg text-center">
            Si vous souhaitez inviter plusieurs fois la même personne, vous
            pouvez passer à
            <span class="cursor-pointer text-pink-600"
              >l'abonnement Premium</span
            >
          </p>
        </div>

        <illustration name="basket" class="w-full" />
      </div>
    </div>

    <div v-else>
      <div class="m-5 lg:m-15 2xl:m-20">
        <h3 class="w-full text-pink-600 mb-10">
          Erreur lors de la création de l'invité !
        </h3>

        <div class="mb-10">
          <p class="text-indigo-600 text-lg text-center">
            L'invité n'a pas pu être créé.
          </p>
        </div>

        <div class="mb-10">
          <p class="text-indigo-600 text-lg text-center">
            Veuillez contacter notre
            <router-link to="aide/contact" class="underline hover:font-medium">
              service technique
            </router-link>
            en indiquant l'adresse mail renseignée
          </p>
        </div>

        <illustration name="notAllowed" class="w-full" />
      </div>
    </div>
  </popup>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import axios from 'axios';
import Popup from './../../../components/Popup.vue';
import Illustration from './../../../components/Illustration.vue';
import InputText from './../../../components/Inputs/InputText.vue';
import ActionButton from './../../../components/ActionButton.vue';
import Icon from './../../../components/Icon';
import CheckboxIndigo from './../../../components/Inputs/CheckboxIndigo.vue';

import Constants from './../../../constants';

export default {
  name: 'AddGuestPopup',

  components: {
    Popup,
    Illustration,
    InputText,
    ActionButton,
    CheckboxIndigo,
    Icon,
  },

  props: {
    isAddGuestPopupOpened: {
      type: Boolean,
      required: false,
      default: false,
    },
    limitGuests: {
      type: Boolean,
    },
  },

  data() {
    return {
      newGuest: {},
      emptyNewGuest: {
        email: '',
        firstname: '',
        lastname: '',
        function: '',
        structure: '',
      },
      existingGuest: {},
      step: 'add_guest',
      errors: {},
      saving_new: false,
      saving_existing: false,
      constants: Constants,
    };
  },

  mounted() {
    this.newGuest = { ...this.emptyNewGuest };
  },

  methods: {
    ...mapActions({
      loadGuests: 'invites/loadGuests',
      me: 'auth/me',
    }),

    ...mapMutations({
      SET_SPECIFICRIGHTSTOEDIT: 'invites/SET_SPECIFICRIGHTSTOEDIT',
    }),

    close() {
      this.step = 'add_guest';
      this.SET_SPECIFICRIGHTSTOEDIT({});
      this.newGuest = { ...this.emptyNewGuest };
      this.errors = {};
      this.existingGuest = {};
      this.$emit('close');
    },

    infosGuestStep() {
      this.step = 'add_guest';
    },

    async permissionsStep() {
      if (Object.keys(this.specificRightsToEdit).length === 0) {
        await this.createPermissionsGrid();
      }

      this.step = 'permissions';
    },

    async createGuest() {
      this.saving_new = true;
      await axios
        .post('api/invite_guest', {
          ...this.newGuest,
          ...{ rights: this.specificRightsToEdit.rights.neopassForm },
        })
        .then((response) => {
          if (response.data === 'new_invitation_sent') {
            this.loadGuests();
            this.me();
            this.step = 'success';
          }
          this.saving_new = false;
        })
        .catch((e) => {
          console.error(e.response.status);
          this.errors = e.response.data.errors;
          this.saving_new = false;
          if (e.response.status != 422) this.step = 'error';
        });
    },

    /* async inviteExistingGuest(){
            this.saving_existing = true;
            await axios.post('api/invite_guest/0', this.existingGuest).then((response) => {
                if (response.data === 'invitation_sent') {
                    this.step = 'success';
                }
                this.saving_existing = false;
            }).catch((e) => {
                if(e.response.data === 'already_invited'){
                    this.step = 'already_invited';
                };
            });
        }, */

    checkall(readOrEdit, moduleName, state) {
      if (moduleName == 'all') {
        //console.log("checkall / readOrEdit = "+readOrEdit+" / mod = "+moduleName+" /state ", state);
        for (let mod in this.specificRightsToEdit.rights.neopassForm[
          readOrEdit
        ]) {
          if (mod != 'all') {
            for (var page in this.specificRightsToEdit.rights.neopassForm[
              readOrEdit
            ][mod]) {
              this.specificRightsToEdit.rights.neopassForm[readOrEdit][mod][
                page
              ] = state;
            }
          }
        }
      } else {
        //console.log("checkall / readOrEdit = "+readOrEdit+" / mod = "+moduleName+" /state ", state);
        for (var page in this.specificRightsToEdit.rights.neopassForm[
          readOrEdit
        ][moduleName]) {
          if (page != 'all') {
            this.specificRightsToEdit.rights.neopassForm[readOrEdit][
              moduleName
            ][page] = state;
          }
        }
      }
    },

    decheckall(readOrEdit, moduleName, state) {
      //console.log("decheckall / readOrEdit = "+readOrEdit+" / mod = "+moduleName+" / page = "+page+" /state ", state);
      if (this.specificRightsToEdit.rights.neopassForm[readOrEdit].all) {
        this.specificRightsToEdit.rights.neopassForm[readOrEdit].all = state;
      }

      if (
        this.specificRightsToEdit.rights.neopassForm[readOrEdit][moduleName].all
      ) {
        this.specificRightsToEdit.rights.neopassForm[readOrEdit][
          moduleName
        ].all = state;
      }
    },
  },

  computed: {
    ...mapGetters({
      listNeopassModulesPages: 'permissions/listNeopassModulesPages',
      specificRightsToEdit: 'invites/specificRightsToEdit',
      permissions: 'auth/permissions',
    }),
  },

  watch: {
    isAddGuestPopupOpened() {
      if (this.isAddGuestPopupOpened && this.limitGuests) {
        this.step = 'limit';
      }
    },
  },
};
</script>
